export type Row = Record<string, any>;
let csrf = "";
export const setCsrf = (token?: string) => {
  csrf = token || "";
};
export class ApiError extends Error {
  code: string;
  status: number;
  constructor(message: string, code: string, status: number) {
    super(message);
    this.code = code;
    this.status = status;
  }
}
export async function api<T = any>(
  url: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch("/api" + url, {
    credentials: "same-origin",
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
      ...options.headers,
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (
      response.status === 401 &&
      payload.error?.code === "AUTHENTICATION_REQUIRED"
    ) {
      setCsrf();
      window.dispatchEvent(new Event("zt:session-expired"));
    }
    throw new ApiError(
      payload.error?.message || "The request could not be completed.",
      payload.error?.code || "REQUEST_FAILED",
      response.status,
    );
  }
  return payload.data === undefined ? payload : payload.data;
}
export const post = <T = any>(url: string, body: unknown = {}) =>
  api<T>(url, { method: "POST", body: JSON.stringify(body) });
export const patch = <T = any>(url: string, body: unknown) =>
  api<T>(url, { method: "PATCH", body: JSON.stringify(body) });
export const remove = <T = any>(url: string) =>
  api<T>(url, { method: "DELETE" });
export function downloadJson(name: string, data: unknown) {
  const a = document.createElement("a");
  const url = URL.createObjectURL(
    new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }),
  );
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
